import { isMobile } from 'react-device-detect';

import { THttpService } from '@/services/HttpService';

import { TInteractionData, TInteractionType } from './types';

const interactionPath = '/recommendation/interactions';

export const setInteraction = async (
  api: THttpService,
  type: TInteractionType,
  { recommendationId }: TInteractionData,
) => {
  await api.post(interactionPath, {
    recommendation_id: recommendationId,
    interaction_type: type,
    device: isMobile ? 'Mobile' : 'Desktop',
  });
};
